// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tolSurfCertDisplay_container__34Qaf {
  display: flex;
  flex-direction: row;
}

.tolSurfCertDisplay_iconContainer__F\\+S-S {
  display: flex;
  flex-direction: column;
  line-height: 1;
}

.tolSurfCertDisplay_pdRg__Wv0Go {
  padding-right: 0.5rem;
}

.tolSurfCertDisplay_smallTitle__nNS\\+V {
  font-size: 0.5rem;
}

.tolSurfCertDisplay_algnCenter__ktUIY {
  display: flex;
  align-items: center;
}

.tolSurfCertDisplay_certificate__Uutiw {
  fill: var(--mainYellow) !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/TolSurfCertDisplay/tolSurfCertDisplay.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;AACpC","sourcesContent":[".container {\n  display: flex;\n  flex-direction: row;\n}\n\n.iconContainer {\n  display: flex;\n  flex-direction: column;\n  line-height: 1;\n}\n\n.pdRg {\n  padding-right: 0.5rem;\n}\n\n.smallTitle {\n  font-size: 0.5rem;\n}\n\n.algnCenter {\n  display: flex;\n  align-items: center;\n}\n\n.certificate {\n  fill: var(--mainYellow) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `tolSurfCertDisplay_container__34Qaf`,
	"iconContainer": `tolSurfCertDisplay_iconContainer__F+S-S`,
	"pdRg": `tolSurfCertDisplay_pdRg__Wv0Go`,
	"smallTitle": `tolSurfCertDisplay_smallTitle__nNS+V`,
	"algnCenter": `tolSurfCertDisplay_algnCenter__ktUIY`,
	"certificate": `tolSurfCertDisplay_certificate__Uutiw`
};
export default ___CSS_LOADER_EXPORT___;
